import {IComponentController, IOnChangesObject} from "angular";
import './sorting-order.component.scss';

export enum SortingOrder {
    ASC = 'OLD_FIRST',
    DESC = 'NEW_FIRST'
}

interface SortingOrderComponentScope {
    sortingOrder: SortingOrder;
    arrowDirectionUp: boolean;
    toggleSortingOrder: () => void;
}

export class SortingOrderComponent implements IComponentController {
    private $scope: SortingOrderComponentScope;
    private sortingOrder: SortingOrder;
    private onChange: (sortingOrder: SortingOrder) => void;

    public static instance = {
        controller: ['$scope', SortingOrderComponent],
        template: require('./sorting-order.component.html'),
        bindings: {
            onChange: '<',
            sortingOrder: '='
        }
    };

    constructor($scope: SortingOrderComponentScope) {
        this.$scope = $scope;
    }

    $onInit(): void {
        this.$scope.arrowDirectionUp = false;
        this.$scope.sortingOrder = this.sortingOrder;
        this.$scope.toggleSortingOrder = this.toggleSortingOrder;
    }

    toggleSortingOrder = () => {
        let asc = this.$scope.sortingOrder === SortingOrder.ASC;
        this.$scope.sortingOrder = asc ? SortingOrder.DESC : SortingOrder.ASC;
        this.$scope.arrowDirectionUp = !this.$scope.arrowDirectionUp;
        this.onChange(this.$scope.sortingOrder);
    };

    $onChanges(onChangesObj: IOnChangesObject): void {
        let changes = onChangesObj['sortingOrder'];
        if (changes && !changes.isFirstChange()) {
            this.sortingOrder = changes.currentValue;
        }
    }
}